import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// Reuses the shared, generic Reports module (public.reports, used
// platform-wide) rather than a Gigs-specific endpoint — this screen is
// just that same admin queue, permanently scoped to reportable_type=
// gig_proposal. Resolving a report here (reviewed/dismissed) syncs the
// underlying GigProposal's status automatically via
// GigProposalReportObserver in jobs-api; this screen never touches the
// proposal directly.
export const gigDisputesList = (params = '') => Http.get(`/admin/reports${serialize(params)}`)
export const gigDisputeReview = (id, data) => Http.patch(`/admin/reports/${id}/review`, data)
